import { useEffect, useState } from 'react'
import { createModel } from 'hox'
import config from '@/config'

const loadImg = (fileUrl: string, fileSize: number, speedKbpsArray: number[]) => new Promise<void>((resolve) => {
  const downloadImg = new Image()
  const startTime = (new Date()).getTime()
  let endTime
  downloadImg.onload = () => {
    endTime = (new Date()).getTime()
    const dura = (endTime - startTime) / 1000
    const speedKbps = Number((fileSize / dura).toFixed(2))
    speedKbpsArray.push(speedKbps)
    resolve()
  }
  downloadImg.src = fileUrl
})

function useMeasureConnectionSpeed() {
  const [networkSpeed, setNetworkSpeed] = useState<number>(0)
  const load = async () => {
    const speedKbpsArray: number[] = []
    await loadImg(`${config.jpg1m}?time=${new Date().getTime()}`, 1.1 * 1024, speedKbpsArray)
    await loadImg(`${config.jpg1m}?time=${new Date().getTime()}`, 1.1 * 1024, speedKbpsArray)
    await loadImg(`${config.jpg1m}?time=${new Date().getTime()}`, 1.1 * 1024, speedKbpsArray)
    const reducer = (previousValue: number, currentValue: number) => previousValue + currentValue
    console.log('networkSpeed', Number((speedKbpsArray.reduce(reducer) / speedKbpsArray.length).toFixed(2)))

    setNetworkSpeed(Number((speedKbpsArray.reduce(reducer) / speedKbpsArray.length).toFixed(2)))
  }

  useEffect(() => {
    load()
  }, [])

  return {
    networkSpeed,
  }
}

export default createModel(useMeasureConnectionSpeed)
